import type { App, InjectionKey, Plugin, ObjectPlugin } from "vue";
import { injectRequired } from "./provide-inject.js";
// define a plugin
const CurrentVueAppKey = Symbol("CurrentVueAppKey") as InjectionKey<App>;
const VueAppRunWithContextKey = Symbol("VueAppRunWithContextKey") as InjectionKey<App[ "runWithContext" ]>;

const ProvideApp_InstallFn: ObjectPlugin<[]>["install"] = (app: App) =>
{
  app.provide(CurrentVueAppKey, app);
  const runWithContextFn = <T> (fn: () => T): T =>
  {
    return app.runWithContext(fn);
  };
  app.provide(VueAppRunWithContextKey, runWithContextFn);
};
export const ProvideAppPlugin: Plugin<[], []> = {
  install (app)
  {
    return ProvideApp_InstallFn(app);
  }
} satisfies Plugin<[], []>;

export function useCurrentApp<T>(): App<T> {
  return injectRequired(CurrentVueAppKey) as App<T>;
}
export function useRunWithContextFn(){
  return injectRequired(VueAppRunWithContextKey);
}